// TODO: find a better solution using the react-select props to fix the fix menu list when the screen is being scrolling

const handleOverflow = (element, isFocused, scrollbarSize) => {
  const isOverflowing = element.scrollHeight > element.clientHeight;
  if (isFocused) {
    element.style.overflow = 'hidden';
    if (isOverflowing) element.style.paddingRight = scrollbarSize + 'px';
  } else {
    element.style.overflow = 'auto';
    if (isOverflowing) element.style.paddingRight = '0px';
  }
};

export const hideScrollBar = (isFocused, propParentElem) => {
  const scrollDiv = document.createElement('div');
  scrollDiv.style.width = '99px';
  scrollDiv.style.height = '99px';
  scrollDiv.style.position = 'absolute';
  scrollDiv.style.top = '-9999px';
  scrollDiv.style.overflow = 'scroll';

  document.body.appendChild(scrollDiv);
  const scrollbarSize = scrollDiv.offsetWidth - scrollDiv.clientWidth;
  document.body.removeChild(scrollDiv);

  const parentEl = document.querySelector('.scrollable-container') || document.querySelector('.viewport');
  const secondaryEl = propParentElem ? document.querySelector(`.${propParentElem}`) : null;

  if (secondaryEl) {
    handleOverflow(secondaryEl, isFocused, scrollbarSize);
    return null;
  }

  if (parentEl === null) return null;

  handleOverflow(parentEl, isFocused, scrollbarSize);
};
